const es = {
  Hi: "Hola",
  Description: "¿Necesitas ayuda?\n Por favor, consulte nuestros documentos.",
  Documentation: "Documentación",
  EnglishLevel: "Nivel de inglés",
  FrenchLevel: "Nivel de francés",
  EnglishExam: "Exámen de inglés",
  FrenchExam: "examen de frances",
  ExamType: "Tipo de examen",
  Score: "Puntaje",
  ReadingScore: "Puntaje de lectura",
  WritingScore: "Puntuación de escritura",
  ListeningScore: "Puntaje de escucha",
  SpeakingScore: "Puntuación de habla",
  ExamDate: "Fecha del examen",
  Yes: "Sí",
  Applicant: "Solicitante",
  Mother: "Madre",
  Father: "Padre",
  Brothers: "hermanos",
  Sisters: "hermanas",
  Children: "Niños",
  Education: "Educación",
  Relations: "Relaciones",
  Languages: "Idiomas",
  Experience: "Experiencia",
  Activities: "Actividades",
  Addresses: "direcciones",
  Travels: "Viajes",
  Passports: "Pasaportes",
  OtherInformation: "Otro",
  DateofDeath: "Fecha de muerte",
  ApplyForVisaCanadaBefore: "¿Usted o alguno de sus familiares ha solicitado alguna vez una visa canadiense? (Turístico, residencial, laboral, educativo, etc.)?",
  VisaCanadaRejectedBefore: "¿Usted o algún miembro de su familia ha tenido alguna vez una solicitud de visa para Canadá u otro país rechazada?",
  ReportedExperience: "¿Usted o alguno de sus familiares ha sido alguna vez deportado de Canadá o de cualquier otro país?",
  ModifiedDate: "Fecha de modificación",
  SaveChanges: "Guardar cambios",
  OveralExamScore: "Puntaje general del examen",
  ExpireDate: "Fecha de caducidad",
  SelectYourLevel: "Seleccione su nivel",
  DidYouHaveExam: "¿Tuviste examen?",
  WitchExam: "¿Examen de brujas?",
  SelectLanguage: "Seleccione el idioma",
  AsylumApplied: "¿Usted, o alguno de sus familiares, ha solicitado asilo alguna vez en Canadá o en cualquier otro país?",
  ArrestedBefore: "¿Usted o alguno de sus familiares ha cometido alguna vez un delito o ha sido arrestado?",
  HealthCareBefore: "Además de tomar medicamentos, ¿usted o algún miembro de su familia necesita ayuda de proveedores de atención médica mientras está en Canadá?",
  StayLongerThanVisa: "¿Usted o un miembro de su familia tiene alguna experiencia de permanecer en Canadá u otro país por más tiempo que la validez de su visa?",
  TerroristHistory: "¿Usted o algún miembro de su familia tiene antecedentes de participación en grupos políticos o grupos terroristas, etc.?",
  SecurityProblems:
    "Explique completamente si usted o alguno de los miembros de su familia tiene antecedentes de mala práctica, problemas de seguridad o acciones previas relacionadas con la visa de Canadá o cualquier otro país.",
  No: "No",
  Expert: "Experto",
  VeryGood: "Muy bueno",
  Good: "Bueno",
  Competent: "Competente",
  Modest: "Modesto",
  Limited: "Limitado",
  None: "Ninguna",
  IELTSGeneral: "IELTS generales",
  IELTSAcademic: "Académico IELTS",
  CELPIPG: "CELPIP-G",
  TEF: "FET",
  CELPIP: "CELPIP",
  Gender: "Género",
  FirstName: "Primer nombre",
  LastName: "Apellido",
  FirstNameNativeLanguage: "Nombre (Idioma nativo)",
  LastNameNativeLanguage: "Apellido (idioma nativo)",
  FirstNameEnglish: "Nombre (inglés)",
  LastNameEnglish: "Apellido (inglés)",
  DateofBirth: "Fecha de nacimiento",
  Height: "Altura",
  EyeColor: "Color de los ojos",
  CityofBirth: "Ciudad de nacimiento",
  CountryofBirth: "País de nacimiento",
  DeathDate: "Fecha de la muerte",
  CityofDeath: "ciudad de la muerte",
  CountryofDeath: "país de la muerte",
  PostalCode: "Código postal",
  JobTitle: "Título profesional",
  Company: "Compañía",
  Email: "Correo electrónico",
  MaritalStatus: "Estado civil",
  ChildNumber: "Número de niño",
  DateofMarriage: "Fecha de casamiento",
  DateofDivorce: "Fecha de divorcio",
  Address: "Dirección",
  NetWorth: "Valor neto",
  EducationLevel: "Nivel de Educación",
  EducationMajor: "Licenciatura en educación",
  MoreAboutEducation: "Más sobre educación",
  WorkExperince: "Experiencia laboral",
  WorkType: "Tipo de trabajo",
  MoreAboutWork: "Más sobre el trabajo",
  PleaseExplainAboutYourEducationHistory: "Por favor explique sobre su historial educativo",
  PleaseExplainAboutYourJobHistory: "Por favor explique sobre su historial de trabajo",
  General: "General",
  Profile: "Perfil",
  AssessmentForm: "Formulario de evaluación",
  SocialLinks: "vínculos sociales",
  ChangePassword: "Cambia la contraseña",
  AccountSettings: "Configuraciones de la cuenta",
  Account: "Cuenta",
  ClientsEvaluated: "Clientes Evaluados",
  ImmigrationCases: "Casos de inmigración",
  TotalPosts: "Publicaciones totales",
  About: "Sobre",
  LiveAt: "Vive en &nbsp",
  YouAreAssessed: "evaluará su información",
  AssessingYou: "Evaluandote",
  AssessMe: "Evalúame",
  HasAccessDocuments: "tiene acceso a sus documentos",
  DisconnectAccess: "Desconectar acceso",
  DocumentAccess: "Acceso a documentos",
  Password: "Clave",
  App: "aplicación",
  user: "usuario",
  List: "Lista",
  Edit: "Editar",
  Shop: "Comercio",
  Blog: "Blog",
  Mail: "Correo",
  Chat: "Charlar",
  Cards: "Tarjetas",
  Posts: "Publicaciones",
  Create: "Crear",
  Banking: "Bancario",
  Booking: "Reserva",
  Product: "Producto",
  Invoice: "Factura",
  Details: "Detalles",
  Checkout: "Verificar",
  Calendar: "Calendario",
  Analytics: "Analítica",
  Ecommerce: "comercio electrónico",
  Management: "Administración de cuentas",
  Menu: "Menú",
  Item_disabled: "Elemento deshabilitado",
  Item_label: "Etiqueta del artículo",
  Item_caption: "Título del artículo",
  Other_cases: "Otros casos",
  Item_by_roles: "Artículo por roles",
  Only_admin_can_see_this_item: "Solo el administrador puede ver este elemento",
  TotalElementarySchool: "Años totales de escuela primaria",
  TotalMiddleSchool: "Total de años de educación media",
  TotalHighSchool: "Años totales de educación secundaria",
  TotalPreUniversity: "Total de años de educación preuniversitaria",
  TotalAssociate: "Años académicos totales de grado asociado",
  TotalUndergraduate: "Total de años de estudio de pregrado",
  TotalMaster: "Total de años de estudio de la maestría",
  TotalDoctoral: "Años totales de estudios de doctorado",
  TotalProfessional: "Años académicos técnicos y profesionales totales",
  Organization: "Organización",
  Degree: "La licenciatura",
  Major: "Importante",
  SelectType: "Seleccione tipo",
  StartDate: "Fecha de inicio",
  EndDate: "Fecha final",
  City: "Ciudad",
  Country: "País",
  Relation: "Relación",
  CityofResidence: "Ciudad de residencia",
  ProvinceofResidence: "Provincia de Residencia",
  ActivityType: "Tipo de actividad",
  ActivityLocation: "Ubicación de la actividad",
  License: "Licencia",
  MoreInformation: "Más información",
  PassportNumber: "Número de pasaporte",
  IssueDate: "Fecha de asunto",
  ExpiryDate: "Fecha de caducidad",
  DayPerWeek: "Día por semana",
  HourPerDay: "Hora por día",
  CompanyPhone: "Teléfono de la empresa",
  CEOName: "Nombre del director ejecutivo",
  CEOPhoneNumber: "Número de teléfono del director ejecutivo",
  YourManagerName: "Su nombre de gerente",
  YourManagerTitle: "Su título de gerente",
  YourManagerPhoneNumber: "Su número de teléfono de gerente",
  CompanyPostalCode: "Código postal de la empresa",
  ActivityLocationHelper: "",
  FullTime: "Tiempo completo",
  PartTime: "Tiempo parcial",
  Citizen: "Ciudadano",
  PermanentResidence: "Residencia permanente",
  TemporaryResidence: "Residencia temporal",
  StatusinCanada: "Estado en Canadá",
  Spouse: "Esposa",
  Background: "Fondo",
  Documents: "Documentos",
  Questioner: "Cuestionario",
  Personal: "Personal",
  PersonalPhoto: "",
  InformationAboutPersonalPhoto: "Información sobre foto personal",
  UploadFile: "Subir archivo",
  PrintTime: "Hora de impresión",
  TranslationDateIfTranslated: "Fecha de traducción (si se traduce)",
  NationalID: "Identificación nacional",
  MilitaryServiceLicense: "Licencia de servicio militar",
  PhotocopyMarriageCertificate: "Fotocopia de la Licencia/Certificado de Matrimonio",
  IDCard: "Tarjeta de identificación",
  PhotocopyDivorceDocuments: "Fotocopia de Actas de Divorcio",
  NumberofChildren: "numero de niños",
  Consultants: "Consultores",
  MyAccount: "Mi cuenta",
  consultant: "Consultor",
  applicant: "Solicitante",
  ShareWhatThinkingAbout: "Comparte lo que estás pensando",
  Post: "Correo",
  Logout: "Cerrar sesión",
  Home: "Hogar",
  Beta: "Beta",
  SignUp: "Inscribirse",
  Dashboard: "Tablero",
  Pages: "Paginas",
  Other: "Otro",
  AboutUs: "Sobre nosotros",
  ContactUs: "Contáctenos",
  Pricing: "Precios",
  Login: "Acceso",
  Register: "Registro",
  ResetPassword: "Restablecer la contraseña",
  WriteComment: "Escribir un comentario…",
  Authentication: "Autenticación",
  SortBy: "Ordenar por",
  Name: "Nombre",
  Applicants: "Solicitantes",
  Immigrationfromhereto: "Inmigración de aquí a",
  Canada: "Canadá",
  BetterProbroadimmigrationplatform: "BetterPro es una amplia plataforma de inmigración que permite a los inmigrantes y consultores encontrarse y mantenerse en contacto",
  GetStarted: "Empezar",
  HowBetterProHelpYou: "¿Cómo te ayuda BetterPro?",
  ServicesForConsultants: "Servicios especiales para consultores",
  Questionnaire: "Cuestionario",
  CollectInformationAboutClients: "Recopilar información sobre los clientes, como su información personal, trabajo, educación, etc., y completar formularios de inmigración con esa información.",
  CollectingDocuments: "Recopilación de documentos",
  GatherDocumentsfromApplicants: "Reúna los documentos de los solicitantes de manera categorizada según las necesidades de cada caso de inmigración.",
  SafeCommunication: "Comunicación Segura",
  ConsultantsApplicantsCommunicate:
    "Los consultores de inmigración y los solicitantes pueden comunicarse a través de BetterPro en todas las etapas del proceso de inmigración (desde la evaluación inicial hasta la obtención de una visa).",
  ProfilePage: "Página de perfil",
  HavinguptodateProfiles: "Tener perfiles actualizados en varios idiomas te ayudará a atraer más clientes",
  PlansCustomized: "Planes que se pueden personalizar",
  ToMeetYourNeeds: "para satisfacer las necesidades de su empresa",
  MakeModernOnline: "Haga que su negocio en línea moderno sea un éxito eligiendo un plan",
  PlusTaxes: " * Más impuestos aplicables",
  mo: "/mes",
  POPULAR: "POPULAR",
  Basic: "básico",
  ThirtyDaysTrial: "30 días de prueba / No se requiere tarjeta de crédito",
  SixtyDaysTrial: "60 días de prueba / No se requiere tarjeta de crédito",
  NinetyDaysTrial: "90 días de prueba / No se requiere tarjeta de crédito",
  MultilanguageProfile: "Perfil multilenguaje",
  Blogging: "bloguear",
  AccessToLeads: "Acceso a clientes potenciales",
  ComminicateWithClients: "Comunicarse con los clientes",
  FullSupport: "Apoyo total",
  Starter: "Inicio",
  Premium: "De primera calidad",
  ChoosePremium: "Elige Premium",
  ChooseStarter: "Elija Inicio",
  ChooseBasic: "Elija Básico",
  GetStartedWith: "empezar con",
  BetterProPlatformToday: "Plataforma BetterPro hoy",
  WhereFindUs: "¿Dónde encontrarnos?",
  FeelFreeContactUs: "Siéntete libre de contactarnos.",
  WeGladHearFromYou: "Estaremos encantados de saber de usted.",
  ToShareYourComment: "Para compartir su comentario sobre",
  PleaseSignup: "Por favor regístrese",
  IAmConsultant: "Soy consultor/abogado de inmigración",
  IAmImmigrate: "Tengo la intención de emigrar a Canadá",
  SelectBestOption: "Seleccione la mejor opción",
  AlreadyHaveAccount: "¿Ya tienes una cuenta?",
  BroadImmigrationPlatformBetterPro: "Amplia plataforma de inmigración con BetterPro",
  GetStartedFree: "Comience absolutamente gratis.",
  NoCreditNeeded: "No se necesita tarjeta de crédito.",
  DontHaveAccount: "¿No tienes una cuenta?",
  EnterDetails: "Introduzca sus datos a continuación.",
  WelcomeBack: "Hola, bienvenido de nuevo",
  RememberMe: "Recuérdame",
  ForgotPassword: "¿Has olvidado tu contraseña?",

  FieldofStudy: "Field of Study",
  TypeofWork: "Type of Work",
  AnnulledMarriage: "Annulled Marriage",
  CommonLaw: "Common-Law",
  DivorcedSeparated: "Divorced / Separated",
  LegallySeparated: "Legally Separated",
  Married: "Married",
  NeverMarriedSingle: "Never Married / Single",
  Widowed: "Widowed",
  RegisterSaveInformation: "Regístrese para guardar información y recibir mensajes de consultores",
  AssessmentForm: "َAssessment Form",
  UserName: "User Name",
  BlogPosts: "Blog Posts",
  NotProfileLanguage: "Consultant does not have a profile for this language. Please select another language.",
  Services: "Services",
  ContactInfo: "Contact Info (Please let the consultant know how best to contact you)",
  PhoneNumber: "Phone Number",
};

export default es;
